export enum Tool {
  WeightManagement = 'weight_management',
  Rationing = 'rationing',
  SmartReco = 'smart_reco',
  RapidReco = 'rapid-reco',
  RenalDetect = 'renal_detect',
  CreatePet = 'create-pet',
}
